












import { Prop, Component, Vue } from "vue-property-decorator";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";

@Component
export default class A01Heading extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: Boolean, required: false, default: false }) showButton!: boolean;
  localShowButton: boolean = false;

  mounted() {
	this.localShowButton = this.showButton;
    this.evaluateShowButton();
  }

  evaluateShowButton() {
	let companyCode: string = auth.user.company_code;
    if (companyCode == "C0001001R" || companyCode == "C10015B8M" || companyCode == "C1000A10B") {
    	this.localShowButton = false;
    }
  }

  get goodsUrl() {
    return process.env.VUE_APP_IC_DOMAIN + CONST_DATA.SITE_MAP.PRODUCT + "?selected=goods";
  }

  get lifeUrl() {
    return process.env.VUE_APP_IC_DOMAIN + CONST_DATA.SITE_MAP.PRODUCT + "?selected=life";
  }
}
